import { NavLink } from "react-router-dom";
import { FiBookOpen, FiUsers, FiUser } from "react-icons/fi";

const navStyle = ({ isActive }) => ({
  color: isActive
    ? "rgb(var(--color-primary))"
    : "rgb(var(--color-text2))",
  fontWeight: isActive ? 700 : 500,
  textDecoration: "none",
  transition: "color 0.18s",
});

export default function TeacherBottomNav() {
  return (
    <nav
      className="
        fixed md:hidden bottom-0 left-0 right-0 flex justify-around items-center h-14 z-40
        backdrop-blur
      "
      style={{
        background: "rgb(var(--color-bg))",
        borderTop: "1px solid rgb(var(--color-border))",
        boxShadow: "var(--shadow-main)",
      }}
    >
      <NavLink
        to="/teacher/classes"
        className="flex flex-col items-center justify-center h-full w-full px-1 py-2 text-xs"
        style={navStyle}
      >
        <FiBookOpen size={20} />
        <span>Lớp học</span>
      </NavLink>
      <NavLink
        to="/teacher/students"
        className="flex flex-col items-center justify-center h-full w-full px-1 py-2 text-xs"
        style={navStyle}
      >
        <FiUsers size={20} />
        <span>Học viên</span>
      </NavLink>
      <NavLink
        to="/teacher/profile"
        className="flex flex-col items-center justify-center h-full w-full px-1 py-2 text-xs"
        style={navStyle}
      >
        <FiUser size={20} />
        <span>Hồ sơ</span>
      </NavLink>
    </nav>
  );
}
